/* eslint-disable @next/next/no-async-client-component */
"use client";
import { useMemo, useState } from "react";
import cn from "classnames";

export interface IEventTeaser {
  className?: string;
}

type TEvenetData = {
  active?: boolean;
  date: string;
  title: string;
  description: string;
};

function Skeleton() {
  return (
    <div className="mx-auto w-full rounded-md py-4">
      <div className="flex animate-pulse space-x-4">
        <div className="flex-1 space-y-6 py-1">
          <div className="space-y-3">
            <div className="h-3 rounded bg-gray-200 w-3/4 mb-4" />
            <div className="h-2 rounded bg-gray-200" />
            <div className="h-2 rounded bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
}

function EventTeaser({ className }: IEventTeaser) {
  const classes = cn(className);
  const [data, setData] = useState([] as TEvenetData[]);
  const [isLoading, setLoading] = useState(true);

  useMemo(() => {
    try {
      fetch("/api/dates")
        .then((res) => res.json())
        .catch(() => setLoading(false))
        .then((data) => {
          setData(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }, []);

  if (isLoading)
    return (
      <>
        <Skeleton />
        <Skeleton />
      </>
    );
  if (!data || !Array.isArray(data))
    return (
      <p className="text-gray-500 text-lg md:text-xl text-left">
        keine anstehenden Termine
      </p>
    );
  return (
    <div className={classes}>
      {Array.isArray(data) &&
        data?.map(
          (event: TEvenetData, i: number) =>
            event.active && (
              <div
                key={`${i}-${event.date}`}
                className="flex flex-col space-y-2 mb-4"
              >
                <p className="font-bold text-2xl text-left">
                  {event.date}, {event.title}
                </p>
                <p className="text-2xl/relaxed">{event.description}</p>
              </div>
            ),
        )}
    </div>
  );
}

export default EventTeaser;
